import React, { useState } from "react";
import {
  useScreen,
  useResend,
  submitPhoneChallenge,
  switchToVoice,
  switchToText,
  returnToPrevious,
  useErrors,
} from "@auth0/auth0-acul-react/phone-identifier-challenge";

const PhoneIdentifierChallengeScreen: React.FC = () => {
  const [code, setCode] = useState("");
  const { data } = useScreen();
  const { hasError, errors } = useErrors();
  const { disabled, startResend } = useResend();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await submitPhoneChallenge({ code });
  };

  const handleResend = (e: React.FormEvent) => {
    e.preventDefault();
    startResend();
  };

  const handleSwitchDelivery = async (e: React.FormEvent) => {
    e.preventDefault();
    if (data?.messageType === "voice") {
      await switchToText();
    } else {
      await switchToVoice();
    }
  };

  const handleReturn = async (e: React.FormEvent) => {
    e.preventDefault();
    await returnToPrevious();
  };

  return (
    <div className="acul-card">
      <h2>Phone Identifier Challenge</h2>
      <p>Enter the code sent to {data?.phone ?? "your phone"}.</p>

      <form onSubmit={handleSubmit}>
        <label htmlFor="code">Code</label>
        <input
          id="code"
          name="code"
          type="text"
          required
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <button type="submit" className="primary">
          Continue
        </button>
      </form>

      <form onSubmit={handleResend}>
        <button type="submit" disabled={disabled}>
          {disabled ? "Resend Limit Reached" : "Resend Code"}
        </button>
      </form>

      {(data?.showLinkVoice || data?.showLinkSms) && (
        <form onSubmit={handleSwitchDelivery}>
          <button type="submit">
            {data?.messageType === "voice" ? "Send code via SMS instead" : "Call me instead"}
          </button>
        </form>
      )}

      <form onSubmit={handleReturn}>
        <button type="submit">Go back</button>
      </form>

      {hasError && (
        <div className="acul-error">
          {errors.map((err) => (
            <p key={err.id}>{err.message}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default PhoneIdentifierChallengeScreen;
